import data from '../data/pants'
import colors from '../data/colors'

const pants = {
  namespaced: true,
  state: {
    data,
    colors,
    selectedArea: {
      id: 1,
      slug: 'base',
      name: 'ベース'
    },
    selectedElement: [
      {
        id: 1,
        slug: 'plain',
        name: '無地',
        area_id: 1,
      },
      {
        id: 3,
        slug: 'switch',
        name: '切り返し',
        area_id: 2,
      },
    ],
    selectedBaseItem: {
      id: 1,
      element_id: 1,
      slug: 'plain'
    },
    selectedDecorateItem: {},
    selectedDecorateItemColor: null,
  },
  mutations: {
    // 選択状態の初期化
    clearPants (state) {
      state.selectedArea = {
        id: 1,
        slug: 'base',
        name: 'ベース'
      }
      state.selectedElement = [
        {
          id: 1,
          slug: 'plain',
          name: '無地',
          area_id: 1,
        },
        {
          id: 3,
          slug: 'switch',
          name: '切り返し',
          area_id: 2,
        },
      ]
      state.selectedBaseItem = {
        id: 1,
        element_id: 1,
        slug: 'plain'
      }
      state.selectedDecorateItem = {}
      state.selectedDecorateItemColor = null
    },
    // エリアの選択
    changeArea (state, payload) {
      state.selectedArea = payload
    },
    // エレメントの選択
    changeElement (state, payload) {
      const addElement = state.selectedElement.concat()
      addElement.unshift(payload);
      state.selectedElement = addElement.filter((item, index, self) => {
        return self.findIndex(i => i.area_id === item.area_id) === index
      })
    },
    // アイテムの選択
    changeBaseItem (state, payload) {
      state.selectedBaseItem = payload;
    },
    changeDecorateItem (state, payload) {
      state.selectedDecorateItem = payload;
    },
    // 色の選択
    changeDecorateItemColor (state, payload) {
      state.selectedDecorateItemColor = payload;
    }
  }
}
export default pants
